import React, { ChangeEvent, FC, useEffect, useState } from 'react'
import { Trans } from 'react-i18next'
import { useParams } from 'react-router-dom'
import t from '../../../../translations/main'
import { checkMode } from 'src/components/Organisms/Form/utils'
import storage from 'src/components/Core/Utils/storage'
import { getEndpointUrl } from 'src/components/Core/Utils/url_constants'
import useFetch from 'src/components/Core/Hooks/useFetch/useFetch'
import { parseJson } from 'src/views/Pages/Onboarding/FormWrapper'

import RadioGroup from 'src/components/Molecules/RadioGroup/RadioGroup'
import Flex from 'src/components/Layout/Flex/Flex'
import Font from 'src/components/Core/Typography/Font/Font'
import InputFilesGroup from '../../Components/InputFilesGroup/InputFilesGroup'
import Button from '../../../../components/Atoms/Button/Button'
import Spinner from 'src/components/Core/Loading/Spinner/Spinner'

import { Underlay } from 'src/views/Pages/Dashboard/EquitySummarySection/EquitySummarySection.styles'
import { ESigItem, ESigModal, ESigTable, FileDetails, IconWrapper, ModalTitle } from './SignatureFormStyles'
import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from '../../../../components/Organisms/Form/Form.styles'
import { SignatureFields, SignaturesGetResponse } from './types'
import { ApiData, FormProps } from '../../../Pages/Onboarding/types'
import Icon from 'src/components/Core/Iconography/Icon/Icon'
// import { openFileNewTab } from 'src/components/Core/Utils/global'

const SignatureForm: FC<FormProps> = props => {
  const [esigSelected, setESigSelected] = useState<string | undefined>()
  const [sigsInfo, setSigsInfo] = useState<SignaturesGetResponse>({
    bothOptionsAvailable: undefined,
    selectedSignatureType: '',
    eSignaturesPackages: [],
    manualSignaturesFiles: []
  })
  const [radioTargetProps, setRadioTargetProps] = useState({value: '', checked: false})
  const [showModal, setShowModal] = useState(false)
  const [isReminder, setIsReminder] = useState(false)
  const [loading, setLoading] = useState(false)
  const [noPackageError, setNoPackageIdError] = useState(false)

  const [openDetails, setOpenDetails] = useState({open:false, id: ''})
  const { step } = useParams()
  const { sendRequest, error } = useFetch()

  const applicationId = storage.get(storage?.keys?.onboarding?.applicationId)

  // @ts-ignore
  const handleSubmit = e => {
    e.preventDefault()
    const modifyResponseForSubmit = (responseData?: ApiData) => {
      const serverValidationErrorsParsed = parseJson(responseData?.reasonPhrase)
      if(Array.isArray(serverValidationErrorsParsed) && serverValidationErrorsParsed.length > 0){
        return
      } else {
        storage.set(storage?.keys?.onboarding?.applicationStatus,'signature_received')
        props.setSubmittedSuccesifully(true)
        props.nextStep(true)
      }
    }
    sendRequest(
      {
        scope: 'onboarding',
        url: getEndpointUrl('Signature/submitManualSignatureFiles', applicationId, 'postMessage.json'),
        method: 'POST',
        body: {
          applicationId
        }
      },
      modifyResponseForSubmit
    )
    console.info('%cFORM SUBMITTED', 'color: green')
  }

  useEffect(() => {
    sendRequest(
      {
        scope: 'onboarding',
        url: getEndpointUrl('Signature/getSignatures', applicationId, 'getSignatures.json'),
      },
      data => {
        if(parseJson(data?.reasonPhrase) || (data.bothOptionsAvailable === 'false' && data.selectedSignatureType !== 'Manual')) {
          setSigsInfo(() => ({
            bothOptionsAvailable: 'error',
            selectedSignatureType: '',
            eSignaturesPackages: [],
            manualSignaturesFiles: []
          }))
          return
        }
        if(data.selectedSignatureType === '') {
          setSigsInfo({
            bothOptionsAvailable: data.bothOptionsAvailable,
            selectedSignatureType: '',
            eSignaturesPackages: [],
            manualSignaturesFiles: []
          })
          setESigSelected('')
          return
        }
        if(data.selectedSignatureType === 'Electronic'){
          sendRequest({
            scope: 'onboarding',
            url: getEndpointUrl('Signature/GetESignatureDetails', applicationId, 'getSignaturesElectronic.json'),
          }, data => {
            const jsonParsedData = parseJson(data?.reasonPhrase)
            if(jsonParsedData && jsonParsedData[0].errordescription?.includes('Package ID not found')){
              setESigSelected('Electronic')
              setSigsInfo({
                bothOptionsAvailable: 'true',
                selectedSignatureType: 'Electronic',
                eSignaturesPackages: [],
                manualSignaturesFiles: []
              })
              setNoPackageIdError(true)
              return
            }
            setESigSelected('Electronic')
            setRadioTargetProps({value: 'Electronic', checked: true})
            setSigsInfo({
              bothOptionsAvailable: 'true',
              selectedSignatureType: 'Electronic',
              eSignaturesPackages: data,
              manualSignaturesFiles: []
            })
          })
        } else if(data.selectedSignatureType === 'Manual') {
          setESigSelected('Manual')
          setRadioTargetProps({value: 'Manual', checked: true})
          setSigsInfo(data)
        }
      }
    )

  }, [])

  // @ts-ignore
  const radioOptions = [
    {
      id: 'signature',
      label: t('onboarding.forms.signature.signatureRadioGroup.eSignature'),
      value: 'Electronic',
      disabled: esigSelected !== '',
    },
    {
      id: 'manualSignature',
      label: t('onboarding.forms.signature.signatureRadioGroup.manualSignature'),
      value: 'Manual',
      disabled: esigSelected !== '',
    }
  ]

  const sendEsigFiles = () => {
    const selectedOption = radioTargetProps?.value
    setLoading(true)
    sendRequest(
      {
        scope: 'onboarding',
        url: getEndpointUrl(
          `Signature/${isReminder ? 'SendESignReminder' : 'setselectedsignatureoption'}`,
          applicationId,
          selectedOption === 'Electronic' ? 'selectSignatureElectronic.json' : 'selectSignatureManual.json',
          `SelectedSignatureType=${selectedOption}`
        ),
        method: 'POST',
      },
      data => {
        if(selectedOption === 'Electronic'){
          sendRequest({
            scope: 'onboarding',
            url: getEndpointUrl('Signature/GetESignatureDetails', applicationId, 'getSignaturesElectronic.json'),
          }, data => {
            const jsonParsedData = parseJson(data?.reasonPhrase)
            if(jsonParsedData && jsonParsedData[0].errordescription?.includes('Package ID not found')){
              setESigSelected('Electronic')
              setShowModal(false)
              setNoPackageIdError(true)
              return
            }
            setLoading(false)
            setShowModal(false)
            setESigSelected('Electronic')
            setSigsInfo({
              bothOptionsAvailable: 'true',
              selectedSignatureType: 'Electronic',
              eSignaturesPackages: data,
              manualSignaturesFiles: []
            })
          })
        } else {
          setLoading(false)
          setShowModal(false)
          setESigSelected(selectedOption)
          setSigsInfo({...data})
        }
      }
    )
    setIsReminder(false)
  }

  useEffect(() => {
    setLoading(false)
  }, [error])

  const handleChange = (callbackArgs: ChangeEvent<HTMLInputElement>) => {
    // @ts-ignore
    setRadioTargetProps(callbackArgs.target)
    setShowModal(true)
  }

  const allSigned = () => {
    // @ts-ignore
    const allDocsSigned = sigsInfo?.eSignaturesPackages?.documentEntries?.every(eSigFile => {
      const allPeopleSigned = eSigFile?.signatureFields?.every((signatory: SignatureFields) => signatory.signed)
      return allPeopleSigned === true
    })
    return allDocsSigned
  }

  // const openElectronicPreview = (id: number) => {
  //   sendRequest({
  //     scope: 'onboarding',
  //     url: getEndpointUrl('Signature/downloadSignatureFile', applicationId, null, `fileid=${id}`),
  //   }, data => {
  //     openFileNewTab(data)
  //   })
  // }

  if(sigsInfo.bothOptionsAvailable === undefined) return <Spinner removeFullscreen />

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>
          {t('onboarding.forms.signature.title')}
        </FormTitle>
      </FormHeader>
      {
        sigsInfo.bothOptionsAvailable === 'error'
          ? <Font>{t('onboarding.forms.signature.errors.noBothOptions')}</Font>
          : (sigsInfo.bothOptionsAvailable === 'true' &&
          <RadioGroup
            name='signatureRadioGroup'
            label={t('onboarding.forms.signature.signatureRadioGroup.label')}
            dataList={radioOptions}
            onChange={handleChange}
            value={esigSelected}
          />)
      }
      {
        noPackageError && <Font>{t('onboarding.forms.signature.errors.noPackageError')}</Font>
      }
      {/*
        If both options are available and none is selected: only the radio group is rendered with no option selected
        If both options are NOT availble (data.bothOptionsAvailable === 'false'): render directly the manual files part with no radio group rendered
        If both options are available and one of them is selected: render the radio group, with disabled options, with the option selected and the corresponding files
      */}
      {
        sigsInfo.bothOptionsAvailable === 'true'
        && esigSelected === 'Electronic'
        && !noPackageError
        && <>
          {/* @ts-ignore */}
          {sigsInfo?.eSignaturesPackages?.documentEntries?.length > 0 && <Font bold margin='48px 0 32px'>{t('onboarding.forms.signature.weHaveShared')}</Font>}
          <ESigTable flexDirection='column' maxWidth as='ul'>
            {
              sigsInfo
              // @ts-ignore
              && sigsInfo.eSignaturesPackages?.documentEntries?.length > 0
                // @ts-ignore
                ? sigsInfo.eSignaturesPackages?.documentEntries.map((eSigFile: DocumentEntriesFiles, index) =>
                  <>
                    <ESigItem maxWidth as='li' key={index}>
                      <Font bold>{eSigFile.name}</Font>
                      <Font color='ultraViolet' bold
                      // onClick={() => openElectronicPreview(eSigFile.id)}
                      >{eSigFile.fileName}</Font>
                      <Font bold color={eSigFile.signatureFields.some((signatory: SignatureFields) => !signatory.signed) ? 'error' : 'green'}>
                        {
                          eSigFile.signatureFields.every((signatory: SignatureFields) => signatory.signed)
                            ? `Signature Completed (${eSigFile.signatureFields?.length} out of ${eSigFile.signatureFields?.length})` //t('onboarding.forms.signature.esigCompleted')
                            : `Pending (${eSigFile.signatureFields?.filter((signatory: SignatureFields) => !signatory.signed)?.length} out of ${eSigFile.signatureFields?.length})`//t('onboarding.forms.signature.esigAwaiting')
                        }
                      </Font>
                      <Icon
                        name='chevron-down'
                        color='ultraViolet'
                        size='m'
                        clickFunction={() => setOpenDetails(prev => {
                          const isSameRow = eSigFile.id === prev.id
                          return {
                            open: isSameRow ? !prev.open : true,
                            id: isSameRow ? '' : eSigFile.id
                          }
                        })}
                      />
                    </ESigItem>
                    {
                      openDetails.open
                      && openDetails.id === eSigFile.id
                      &&
                        <FileDetails maxWidth flexDirection='column' alignItems='flex-start'>
                          {
                            eSigFile.signatureFields?.map((signatory: SignatureFields) => {
                              return <Flex maxWidth justifyContent='space-evenly' key={eSigFile.id}>
                                <Font width='50%'>{signatory.name}</Font>
                                <Font
                                  width='50%'
                                  color={signatory.signed ? 'green' : 'error'}
                                  bold
                                >
                                  {signatory.signed ? 'Completed' : 'Pending' }
                                </Font>
                              </Flex>
                            })
                          }
                        </FileDetails>
                    }
                  </>
                )
                : <Font>{t('onboarding.forms.signature.errors.noBothOptions')}</Font>
            }
          </ESigTable>
          {
            allSigned() &&
              <Flex>
                <IconWrapper>
                  <Icon name='check' size='s' color='blank' />
                </IconWrapper>
                <Font bold color='green'>    e-Signature has been completed</Font>
              </Flex>
              //TODO: uncomment section below when endpoint for re-sending the pack is done
              // : <Button
              //   version={2}
              //   label={t('onboarding.forms.signature.resendPack')}
              //   buttonMargin='0 0 80px 0'
              //   onClick={() => {
              //     setShowModal(true)
              //     setIsReminder(true)
              //   }}
              // />
          }
        </>
      }
      {
        esigSelected === 'Manual'
        && sigsInfo
        && (sigsInfo.manualSignaturesFiles?.length > 0
          ? sigsInfo.manualSignaturesFiles.map((inputGroup, index) =>
            <InputFilesGroup
              itemKey={inputGroup.groupName}
              key={inputGroup.groupName}
              // @ts-ignore
              value={inputGroup.groupFiles}
              // @ts-ignore
              groupLabel={<Trans i18nKey={'onboarding.forms.signature.inputFilesGroupLabel'}  values={{ groupName: inputGroup.groupName || 'files' }} />}
              step={step}
              fetchOptions={{
                requestConfig: {url: getEndpointUrl('Signature/uploadSignedFile', applicationId, 'postMessage.json')}
              }}
              singleFileInput
              // @ts-ignore
              margin={index === sigsInfo.manualSignaturesFiles.length - 1 ? '32px 0 64px' : '32px 0 0'}
              inputMargin='0'
              groupLabelMargin='0 0 16px'
              customSignatureOnChange={(file, index, data) => setSigsInfo(prev => {
                const newFilesInfo = {...prev}
                newFilesInfo.manualSignaturesFiles[0].groupFiles[`${index}`].uploadedFileName = file.name
                newFilesInfo.manualSignaturesFiles[0].groupFiles[`${index}`].uploadedFileID = data.toString()
                return newFilesInfo
              })}
              customOnDelete={deletedFile => {
                if(!deletedFile?.name) return
                setSigsInfo(prev => {
                  const newFilesInfo = {...prev}
                  // TODO: if there is going to be more than one group of file then change the manualSignaturesFiles indexing to be dynamic
                  const fileIndexToRemove = newFilesInfo.manualSignaturesFiles[0].groupFiles.findIndex(file => deletedFile.documentID === file.uploadedFileID)
                  newFilesInfo.manualSignaturesFiles[0].groupFiles[`${fileIndexToRemove}`].uploadedFileName = ''
                  return newFilesInfo
                })
              }}
              noFilterOutName
              isSignature
              disabled={checkMode('readOnly')}
            />
          )
          : <Font>{t('onboarding.forms.signature.errors.noBothOptions')}</Font>)
      }
      {
        showModal && <>
          <Underlay />
          <ESigModal alignItems='center' justifyContent='flex-start' flexDirection='column'>
            <ModalTitle>{t('onboarding.forms.signature.modalTitle')}</ModalTitle>
            { loading
              ? <Spinner removeFullscreen />
              : <>
                <Flex maxWidth justifyContent='flex-start' flexDirection='column'>
                  <Font margin='25px 32px 40px 32px'>{
                    radioTargetProps.value === 'Electronic'
                      ? t('onboarding.forms.signature.confirmToSend')
                      : t('onboarding.forms.signature.confirmToSendManual')
                  }</Font>
                  <Flex maxWidth justifyContent='center'><span /></Flex>
                </Flex>
                <Flex maxWidth justifyContent='flex-end'>
                  {/* @ts-ignore */}
                  <Button version={2} buttonMargin='0 16px 0 0' label='Yes' onClick={() => sendEsigFiles()} />
                  <Button label='No' onClick={() => {
                    // @ts-ignore
                    if(!sigsInfo.eSignaturesPackages?.documentEntries || sigsInfo.eSignaturesPackages?.documentEntries?.length === 0){
                      // @ts-ignore
                      radioTargetProps.checked = false
                      setESigSelected('')
                    }
                    setShowModal(false)
                  }}/>
                </Flex>
              </>
            }
          </ESigModal>
        </>
      }
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          <Button
            label={t('onboarding.main.backButton')}
            version={2}
            disabled={props.disablePrev}
            onClick={props.prevStep}
          />
        </FormFooterActionsLeft>
        {
          esigSelected === 'Manual' &&
          <FormFooterActionsRight>
            <Button
              type='submit'
              label={t('onboarding.main.continueButton')}
              disabled={sigsInfo?.manualSignaturesFiles?.[0]?.groupFiles.filter(file => file.uploadedFileName !== '').length < sigsInfo?.manualSignaturesFiles?.[0]?.groupFiles.length}
            />
          </FormFooterActionsRight>
        }
      </FormFooter>
    </FormStyle>
  )
}

export default SignatureForm
